import { Link } from "react-router-dom";
import moment from "moment-timezone";

import AdvanceTableWrapper from "../common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "../common/advance-table/AdvanceTable";
import AdvanceTableFooter from "../common/advance-table/AdvanceTableFooter";
import { Button, Col, Row } from "react-bootstrap";
import AdvanceTableSearchBox from "../common/advance-table/AdvanceTableSearchBox";
import Flex from "../common/Flex";
import PATH from "../../routes/RoutePath";
import useParamsHandler from "../../utils/hooks/useParamsHandler";

const UserReportListTable = ({
  data,
  page,
  limit,
  searchQuery,
  userTypeQuery,
  weeklyAvgResTime,
}) => {
  const { searchParams, searchParamsHandler } = useParamsHandler();
  const totalCount = data?.totalCount || 1
  const column = searchParams.get("column") || "createdOn";
  const order = searchParams.get("order") || "desc";
  const sortHandler = (col, ord) => {
    // setPage(1);

    if (col === "createdOn") {
      ord === "asc" && searchParamsHandler("column", col, "order", "desc");
      // setSortQuery({
      //   column: column,
      //   order: "desc",
      // });
      ord === "desc" && searchParamsHandler("column", col, "order", "asc");
      // setSortQuery({
      //   column: column,
      //   order: "asc",
      // });
    } else {
      !ord && searchParamsHandler("column", col, "order", "asc");
      // setSortQuery({
      //   column: column,
      //   order: "asc",
      // });
      ord === "asc" && searchParamsHandler("column", col, "order", "desc");
      // setSortQuery({
      //   column: column,
      //   order: "desc",
      // });
      ord === "desc" && searchParamsHandler("column", col, "order", "asc");
      // setSortQuery({
      //   column: "createdOn",
      //   order: "desc",
      // });
    }
  };
  const columns = [
    {
      accessor: "reportId",
      Header: () => (
        <>
          Report Id{" "}
          <span
            className={`sort ${column === "reportId" && order}`}
            onClick={() => {
              sortHandler("reportId", column === "reportId" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { reportId, id } = rowData.row.original;
        return (
          <Link to={PATH.REPORTS.USER_REPORT_DETAILS + id}>{reportId ?? "N/A"}</Link>
        );
      },
    },
    {
      accessor: "createdOn",
      Header: () => (
        <>
          Reported At{" "}
          <span
            className={`sort ${column === "createdOn" && order}`}
            onClick={() => {
              sortHandler("createdOn", order);
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { createdOn } = rowData.row.original;
        return (
          <td>
            {createdOn
              ? moment(createdOn)
                  .tz("Australia/Brisbane",false)
                  .format("DD-MM-YYYY, h:mm:ss A")
              : "N/A"}
          </td>
        );
      },
    },
    {
      accessor: "reporteeType",
      Header: () => (
        <>
          User Type{" "}
          <span
            className={`sort ${column === "reporteeType" && order}`}
            onClick={() => {
              sortHandler("reporteeType", column === "reporteeType" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { reporteeType } = rowData?.row.original;
        // const ownerType = "b-user";
        return (
          <td>
            {(reporteeType === "b-user" && "Business") ||
              (reporteeType === "c-user" && "Charity") ||
              (reporteeType === "g-user" && "General") ||
              (reporteeType === "admin" && "Admin") ||
              (reporteeType === "super-admin" && "Super Admin") ||
              (!reporteeType && "N/A")}
          </td>
        );
      },
    },

    {
      accessor: "reportsCount",
      Header: "Total Reports",
      disableSortBy: true,
      Cell: (rowData) => {
        const { reportCount } = rowData.row.original;
        return <td>{reportCount}</td>;
      },
    },
    {
      accessor: "reportee.displayName",
      disableSortBy: true,
      Header: "Reportee",
      Cell: (rowData) => {
        const { reporteeDisplayName,reporteeId } = rowData.row.original;
        return (
          <>
            {reporteeId ? (
              <Link
                style={{ color: "var(--falcon-primary)" }}
                to={PATH.USERS.USER_PROFILE + reporteeId}>
                {reporteeDisplayName || "N/A"}
              </Link>
            ) : (
                reporteeDisplayName || "N/A"
            )}
          </>
        );
      },
    },
    {
      accessor: "reporter.displayName",
      Header: "Reported By",
      disableSortBy: true,
      Cell: (rowData) => {
        const { reporterDisplayName,reporterId } = rowData.row.original;
        return (
          <>
            {reporterId ? (
              <Link
                // style={{ color: "var(--falcon-primary)" }}
                to={PATH.USERS.USER_PROFILE + reporterId}>
                {reporterDisplayName || "N/A"}
              </Link>
            ) : (
                reporterDisplayName || "N/A"
            )}
          </>
        );
      },
    },
    {
      accessor: "reason",
      Header: () => (
        <>
          Reason{" "}
          <span
            className={`sort ${column === "reason" && order}`}
            onClick={() => {
              sortHandler("reason", column === "reason" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { reason, otherText } = rowData.row.original;
        return (
          <td>{reason || (otherText && `Other-${otherText}`) || "N/A"}</td>
        );
      },
    },
    {
      Header: "Action",
      Cell: (rowData) => {
        const { reporteeEmail,reporteeDisplayName, reason, otherText } = rowData.row.original;

        return (
          <a
            size="sm"
            className="btn btn-primary btn-sm"
            href={`mailto:${
              reporteeEmail
            }?subject=ATTN: Your%20Clip%20has%20been%20Reported.%20Action%20is%20required.&body=Hi%20${
                reporteeDisplayName
            },%0D%0DYour%20Clip%20has%20been%20recently%20reported${
              !(reason || otherText) ? "." : `%20for%20${reason || otherText}.`
            }`}
          >
            Send Email
          </a>
        );
      },
    },
  ];
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data?.list || []}
      pagination
      style={{}}
      perPage={data.limit}>
      <Row className="flex-end-center mb-3">
        <Col xs="auto" sm={10} lg={6}>
          <AdvanceTableSearchBox
            table
            filter={["userType"]}
            searchQuery={searchQuery}
            userTypeQuery={userTypeQuery}
          />
        </Col>
      </Row>

      {/*<Row className="flex-end-center mb-3">*/}
      {/*  <Col xs="auto" sm={8} lg={6}>*/}
      {/*    <Flex justifyContent={"end"}>*/}
      {/*      {weeklyAvgResTime && (*/}
      {/*        <span*/}
      {/*          className=""*/}
      {/*          style={{ fontSize: "12px", color: "var(--falcon-primary)" }}>*/}
      {/*          {weeklyAvgResTime?.days ? (*/}
      {/*            <>*/}
      {/*              Weekly Avg. Response Time:*/}
      {/*              <b style={{ fontSize: "16px" }}>*/}
      {/*                {" "}*/}
      {/*                {weeklyAvgResTime?.days || 0}{" "}*/}
      {/*              </b>*/}
      {/*              Days{" "}*/}
      {/*              <b style={{ fontSize: "16px" }}>*/}
      {/*                {weeklyAvgResTime?.hours || 0}*/}
      {/*              </b>{" "}*/}
      {/*              Hours{" "}*/}
      {/*              <b style={{ fontSize: "16px" }}>*/}
      {/*                {weeklyAvgResTime?.minutes || 0}*/}
      {/*              </b>{" "}*/}
      {/*              Minutes*/}
      {/*            </>*/}
      {/*          ) : weeklyAvgResTime?.hours ? (*/}
      {/*            <>*/}
      {/*              Weekly Avg. Response Time:*/}
      {/*              <b style={{ fontSize: "16px" }}>*/}
      {/*                {" "}*/}
      {/*                {weeklyAvgResTime?.hours || 0}*/}
      {/*              </b>{" "}*/}
      {/*              Hours{" "}*/}
      {/*              <b style={{ fontSize: "16px" }}>*/}
      {/*                {weeklyAvgResTime?.minutes || 0}*/}
      {/*              </b>{" "}*/}
      {/*              Minutes*/}
      {/*            </>*/}
      {/*          ) : weeklyAvgResTime?.minutes ? (*/}
      {/*            <>*/}
      {/*              Weekly Avg. Response Time:*/}
      {/*              <b style={{ fontSize: "16px" }}>*/}
      {/*                {" "}*/}
      {/*                {weeklyAvgResTime?.minutes || 0}*/}
      {/*              </b>{" "}*/}
      {/*              Minutes*/}
      {/*            </>*/}
      {/*          ) : weeklyAvgResTime?.seconds > 0 ? (*/}
      {/*            <>*/}
      {/*              Weekly Avg. Response Time:*/}
      {/*              <b style={{ fontSize: "16px" }}> {1}</b> Minutes*/}
      {/*            </>*/}
      {/*          ) : (*/}
      {/*            ""*/}
      {/*          )}*/}
      {/*        </span>*/}
      {/*      )}*/}
      {/*    </Flex>*/}
      {/*  </Col>*/}
      {/*</Row>*/}

      {data?.list?.length > 0 ? (
        <AdvanceTable
          table
          headerClassName="bg-200 text-900 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: "fs--1 mb-0 overflow-hidden",
          }}
        />
      ) : (
        <p>No Reports Found</p>
      )}

      <div className="mt-3">
        <AdvanceTableFooter
          currentPage={page}
          limit={limit}
          rowCount={data?.limit}
          totalCount={totalCount}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
          pagination
        />
      </div>
    </AdvanceTableWrapper>
  );
};

export default UserReportListTable;
